<footer class="app-footer">
  <div class="footer-inner">
    <div class="footer-grid">
      <div class="footer-col">
        <div class="app-footer-list"><strong>CÔNG TY CỔ PHẦN DỊCH VỤ VÀ THƯƠNG MẠI NEXTRA</strong></div>
        <p class="muted"><strong>Mã số thuế:</strong> 0318729683</p>
        <p class="muted"><strong>Địa chỉ Thuế:</strong> Tầng 1, Toà nhà Maxic, Số 3, Trà Khúc, Phường Tân Sơn Hòa, TP Hồ Chí Minh, Việt Nam</p>
        <p class="muted"><strong>Địa chỉ:</strong> Tầng 1, Toà nhà Maxic, Số 3, Trà Khúc, Phường 2, Quận Tân Bình, Thành phố Hồ Chí Minh, Việt Nam</p>
        <p class="muted"><strong>Tình trạng:</strong> Đang hoạt động</p>
        <p class="muted"><strong>Tên quốc tế:</strong> NEXTRA SERVICES AND TRADING JOINT STOCK COMPANY</p>
      </div>

      <div class="footer-col partners">
        <h4 class="app-footer-title">🤝 Đối tác</h4>
        <div class="partners-list" aria-label="Đối tác">
          <span class="partner-badge" title="Shopee">Shopee</span>
          <span class="partner-badge" title="Lazada">Lazada</span>
          <span class="partner-badge" title="Tiki">Tiki</span>
          <span class="partner-badge" title="Viettel Post">Viettel Post</span>
        </div>

        <h4 class="app-footer-title mt">👥 Thống kê</h4>
        <div class="stats-row" role="list">
          <div class="stat" role="listitem">
            <div class="stat-number">10k+</div>
            <div class="stat-label">Khách hàng</div>
          </div>
          <div class="stat" role="listitem">
            <div class="stat-number">500+</div>
            <div class="stat-label">Đối tác</div>
          </div>
          <div class="stat" role="listitem">
            <div class="stat-number">1M+</div>
            <div class="stat-label">Giao dịch</div>
          </div>
        </div>
      </div>

      <!-- Removed policy/support/security/social sections as requested -->
    </div>

    <div class="footer-bottom">
      <div class="copy">© 2026 CÔNG TY CỔ PHẦN DỊCH VỤ VÀ THƯƠNG MẠI NEXTRA. All rights reserved.</div>
    </div>
  </div>
</footer>
